import TooManyRequestPage from './TooManyRequestPage';

export default TooManyRequestPage;
